var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showCard)?_c('binds-card',_vm._g(_vm._b({staticClass:"binds-app-content binds-flex"},'binds-card',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2):_c('binds-content',_vm._g(_vm._b({staticClass:"binds-app-content binds-flex"},'binds-content',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }